
<div class="main-content">
  <div class="login-page-wrapper">
    <!-- Desert SVG Background -->
    <svg class="login-background" viewBox="0 200 1920 880" preserveAspectRatio="none" aria-hidden="true"
      focusable="false">
      <path class="svg-layer-6" fill="var(--svg-6)"
        d="M1921 450v631H1q-.1-316 .4-632.5c2.6-.2 5 1 7 .4q7.5-2.4 14.6-5.7c5.5-2.5 10.8-3 16.6-.2q20 9.5 40.2 18.6c.9.4 2.2 0 3.3-.3l24-8.5q11-3.7 22-7.8c7.2-2.7 14.3-6 21.7-8.3 7.2-2.3 14.6-3.9 22-5.6l33.6-7.8q4-.7 7.8-1.6l49.8-15.2 40-12c4-1.3 8-3 12-4.2q3.7-1.1 7.4-1.2 10.7.3 21.4.9c1 0 2.2-.3 3 .2 3.2 2.3 6 1.3 9.6 0q26.8-8.8 53.8-17.2c15.5-4.9 31.3-9 46.7-14.6 12.4-4.6 25-6 38-5.4 5.8.2 11.7-.2 17.5 0q7.1.5 13-3.6c3.7-2.5 7.9-4.2 11.8-6.3l31.3-16.6c4.8-2.5 9.5-6 14.7-7.1a270 270 0 0 1 30.6-4.3q20.1-1.8 40.2-3.2c4.3-.3 8.8.1 12.8-1.3 11.7-4.1 23.2-9 34.8-13.5l30.3-12 44-17.2 39.4-14.9q7.2-2.9 14.3-5.3 15-4.6 30.3-8.7c5.6-1.4 11.5-1.5 17-2.9a92 92 0 0 1 29.2-1c17 1.2 34 3.3 51 3.7 14.6.3 29.2-1 43.7-1.9 6.6-.4 13.2-1.4 19.8-1.8 6-.5 12-1.4 17.8-.6 11.6 1.6 23 4.4 34.6 6.5 8.3 1.5 16.4 2.7 24.1 6.7 8.8 4.5 18.3 7.4 27.5 11q22.5 9 45 17.6l54.5 20.8c6.1 2.3 11.9 5.6 18 7.6 8 2.6 15.6 6.2 24.2 6.4 9.3.4 18.5 1.7 27.7 2.7l26.8 3.2c5.5.5 11 .4 16.4 1.2 3.5.5 7 2 10.1 3.5q13.7 6.9 27.2 14.1c5.6 2.9 11.5 5.2 16.7 8.5 8.5 5.5 17 10 27.6 8.8 6.4-.6 13 0 19.5-.1q13.4-.5 26.2 4c20 7.1 40.4 13.2 60.7 19.5 3.6 1.2 7.4 1.7 11 3l37.2 12.3c1 .3 2.2-.3 3.4-.3l31.9-1.7q1 0 2 .4 23 7.5 46.3 14.8a1502 1502 0 0 0 78 22c8 2.1 16.2 4.4 24.4 6 13.7 2.6 26.8 7.2 39.7 12.4 15 6 30.2 10.9 45.4 16.2q1.7.3 3.3-.4 10.5-4.5 20.8-9.2c6-2.8 12-6 18.1-8.5 3.1-1.3 7-3 9.8-2.3 8 2.3 15.7 5.8 23.5 8.8" />
      <path class="svg-layer-5" fill="var(--svg-5)"
        d="M1921 554v527H1q-.1-254.8.4-510.7 7.3-3.3 14.2-5.2c11.5-3.2 23-6.2 33.2-13 10.8-7.1 22-13.6 33-20.4 5.3-3.3 10.1-7.4 17.2-4.8 2.7 1 5.9.6 8.8 1.1 9.6 1.7 19.7 2.4 28.8 5.7 9.4 3.4 18 9.3 26.8 14.3l36.7 21q1.8 1 3.7.9l15.8-4c7.4-1.7 14.5-5 22.6-3q14.6 3.1 29.3 5.7c5.4 1 10.9 2.9 16.3-.9 3.6-2.5 8.2-3.5 11.8-6.1 9.6-7 21-9.6 31.7-13.5 12-4.4 24.4-8.1 36.6-12l37.9-12 34-11c14.3-4.5 28.5-9.5 43-12.7 18-4 33.9-12.6 50.5-19.6 11.7-5 22.9-11 34.5-16 4.1-1.8 9-2.6 13.4-2.7 13.5-.3 27 0 40.5-.2q6.6 0 13-2l38.4-12a36 36 0 0 1 12-1.7c11.6 1.2 23 3.3 34.5 4.7l38 4.6q14.7 2 29.2 4.4l25.6 4.2c6 1 11.8 2.8 17.7 3.7 4.3.5 9.3 1.4 13-.2 8.4-3.8 16-9 24.2-13.5q15.2-8.4 30.5-16.4 12-6.7 24.2-13.1c3.4-1.8 7-2.6 10.8-.8q4.6 1.9 9.6 3.2l40.6 12.5 43 13c3.4 1 6.8 2.4 10.3 3 9 1.6 17 8.3 27 4.5 5-1.9 10.5-2.6 15.5-4.6 4.3-1.8 8.2-3 12.8-1.7q8.2 2 16.6 3.3 17.7 3 35.3 6.3a14 14 0 0 1 5.5 2.3q8.3 6 16.4 12.3l19.5 15q13.4 10.3 27.2 20.2c4.7 3.5 9.4 7.7 14.7 9.5 5.1 1.8 11.2 1 16.8 1.4 8.6.8 17.4 1 25.8 2.9 15.7 3.6 31.1 8.5 46.7 12.6 8.2 2.1 16.4 4.7 24.7 5.2 7.8.4 15.8-1.7 23.7-2.7l24.6-2.9q12.9-1.7 25.8-3c8.9-1 17.8-1.4 26.7-2.2 3.4-.4 7.2-.4 10-2q25.2-13.9 50-28.2c4.6-2.6 8.9-5.6 13.5-8 1.5-.8 4-.9 5.4-.1l26.2 13.7c9.9 5.1 20.2 9.4 29.6 15.1a26 26 0 0 0 19 3q11-1.9 22.3-3.4a221 221 0 0 1 16.2-1.8c7.1-.4 14.4-2 21.2 1.7q2.9 1.7 5.7 2.9l31.3 11.3 76.7 29c3.8 1.4 7.2 2.3 11.3.1 6.4-3.5 13.3-6.1 20-9.2 7.2-3.3 14.6-6.2 21.5-10.1 9.9-5.7 18.6-2.8 27.9 1.5 9.7 4.5 19.4 9 31 7.7 13.4-1.6 27-2.1 40.6-3.1" />
      <path class="svg-layer-5a" fill="var(--svg-4)"
        d="M1450 640c-5.74 2.42-11.02 5.12-16.6 6.84-3.48 1.07-5.16-2.1-4.1-4.86 3.57-9.3.6-18.28-.5-27.39-.22-1.88-.73-4-.13-5.67 2.62-7.23-.12-13.58-2.68-20.03-2-5.06-4.12-10.08-5.89-15.22-2.2-6.37.88-12.27 7.49-13.53 6.13-1.18 12.4-1.79 18.65-2.07 8.08-.37 13.56-6.88 11.96-14.86-1.1-5.5 1.33-7.7 6.8-6.8 5.2.84 10.52.92 15.74 1.66 2 .28 4.72.94 5.56 2.35.71 1.2-.5 3.87-1.38 5.64-1.74 3.55-3.83 6.92-6.66 11.94 5.41-.57 9.48-.96 13.53-1.43 4.26-.49 8.49-1.34 12.75-1.5 4.54-.17 6.1 2.62 3.4 6.35-4.62 6.42-9.92 12.37-14.48 18.83-1.77 2.52-2.14 5.99-3.48 8.87a65 65 0 0 1-4.67 8.25c-4.64 7.03-9.66 13.81-14.06 20.98-5.4 8.78-12.17 16.06-21.24 21.65" />
      <path class="svg-layer-4" fill="var(--svg-4)"
        d="M1 664.5q17.3-4.8 34.7-8.8l26.6-6.7 21.8-6c5.7-1.5 11.3-3.4 17-4.4 4-.7 8.2.4 12-.3 8-1.4 15.6-4.1 23.5-5.1 10.2-1.4 20.4-1.6 30.6-2.2 3.7-.2 7.4.3 11 0l31.3-3.7 13.3-1.3q3.9-.5 7.6-1.8c2.2-.9 4 .7 6.4 0 7.7-1.9 15.7-2.5 23.6-4q16.2-2.9 32.3-6.2c10.2-2 20.6-3.6 30.7-6 14.9-3.7 29.9-7 44.2-12.4 10.1-3.7 19.7-2.7 29.6-1.7 7.8.8 15.5 2.2 23.2 2a122 122 0 0 0 34.7-6.6c7-2.4 14.7-2.8 22-4.3 9.2-2 18.4-3.5 27.3-6.2 12-3.4 23.7-7.7 35.5-11.8 7.3-2.5 14.4-6 21.8-7.8 6.3-1.6 13-1.7 19.5-2.2 7.3-.5 14.7.3 21.8-1.2 8-1.6 15.8-5.4 23.8-7.6 7.2-1.9 14.7-2.5 21.8-4.3 15.3-3.8 31-1.5 46.3-3.7 2.7-.3 5.7 1 8.5 1.9q9.5 2.7 18.8 5.9c13.4 4.3 26.7 9 40.2 12.9 6.9 2 14 2.9 21.1 4l27.2 4.5 8.7 1.3q20 3 39.8 6.4c6.3 1 12.4 3 18.7 3.9q12 1.7 22.9 7c5.8 2.9 11.4 6.4 17.4 8.4 5.7 2 11.8 2.4 17.7 3.6l28.6 6 30.8 6q15.2 2.8 30.5 5.4c11 1.9 22 3.4 32.8 5.8a72 72 0 0 1 15.8 6c4.2 2.1 8 5.2 12 7.5 11.8 6.6 23.3 13.6 35.4 19.4 6.3 3 13.6 4.4 20.6 5.8 9.3 1.8 18.7 2.8 28 4.3q11.9 1.8 23.7 3.8l28.7 5.4c11.9 2.2 23.8 4 35.6 6.7 5.6 1.3 11.5 3.1 15.9 6.5s8.6 3.1 13 2.2q34.4-6.8 68.7-13.8c4.6-1 9.3-1.7 13.8-3 8.8-2.6 17.3.4 25.9 1.4q15.5 2 31 4.6l30.1 4.4c10 1.5 20.2 2.6 30 4.7 16.7 3.6 32.3-2.3 48.3-4.7 13.7-2.1 27.3-5 41-7.2 2-.4 4.7.8 6.6 2l23.4 16.3c1.1.8 2.7 1.4 4 1.4 8 .5 16 .2 23.8 1.2 18 2.4 34.6-3.8 51.8-6.5 7.6-1.2 15-3.3 22.6-4.4 2-.3 5 .9 6.6 2.4 3.5 3.2 7 5 12 4.5q11.4-1.1 22.8-1c3.1 0 6.7 1 9.2 2.6 3.7 2.5 7.2 2.6 11.3 1.8 3-.7 6.1-.8 9.2-1.2l16.3-2 30-4.2c7.7-1 15.5-1.5 23-3.3 5.8-1.4 11.2-4.5 16.8-7l28.2-13.2q13.3-6.4 27-12.7.4 213.6.3 427H1z" />
      <path class="svg-layer-3" fill="var(--svg-3)"
        d="M1 606.5a52 52 0 0 1 29.7 7.8l2.2 1.1q17.5 8.2 34.8 16.6 13.1 6.1 25.8 13a637 637 0 0 1 34.6 19.8c9.6 6 19 10.9 30.8 9.4a26 26 0 0 1 14.2 2c7.5 3.8 14.2 9.2 21.4 13.8q11.6 7.5 23.4 14.4 10.6 6.1 22 10.9c16 6.5 32.4 12.3 48.4 19 10.9 4.5 21.5 9.2 33.1 12 13.4 3 26.5 7.8 39.7 11.7 12.6 3.7 25.4 6.7 37.6 11.3 6.2 2.3 11.6 7 17 11.2 6.7 5.3 12.9 11.4 19.4 17l20.7 17.9c3.3 2.8 6.2 6.2 9.8 8.6 7 4.4 12 10.8 18.5 15.8 10.4 8.2 20.2 17.4 30.3 26 .7.7 2 1 3 1.2h4q458.3 0 916.4.3a31 31 0 0 0 23.4-9.9q7.3-6.9 15-13.5l32.7-28.3c14.9-12.7 30.4-24.5 44.4-38 7.6-7.4 16.8-8.7 25.7-11.5 13.8-4.3 27.7-8 41.5-12.1q9.7-2.9 19-6 13.5-4.2 26.8-9.2c8.5-3.2 16.7-7.1 25.1-10.5 6-2.4 12.3-4.1 18.3-6.7 15.4-6.6 31.4-11.5 45-22.1 10.9-8.4 23.8-14 35.1-21.7 5-3.3 9.5-4 14.8-3.8 2.2 0 4.4-.3 6.5 0 10.2 1.7 17.5-4.2 25.4-9l13-7.2 16.9-10.4q7.2-4.4 14.9-8l17.7-8 21.6-10.4q.5 230 .4 460H1z" />
      <path class="svg-layer-2" fill="var(--svg-2)"
        d="M1 900.5q9.4-2.7 18.8-4.5 12.7-2.2 25.4-4c8.4-1.4 16.8-2.3 25-4.2a67 67 0 0 0 15.2-6c4.3-2.2 8.2-5.4 12.3-8q18-11.5 36.3-22.8l20.6-13c8.6-5.5 17.3-10.8 25.5-16.7 8.2-6 16.7-8.6 27.1-8.5 40 .2 80.2-.5 120.3-.8a68 68 0 0 1 26.4 5.8c5.5 2.2 11.9 2.1 17.3 4.4 6.2 2.5 12.4 1.6 18.6 1.8 9.6.1 19.3-.3 29 0q27.6 1.3 55.3 3l12.7 1 34 4c5 .4 10 .1 14.7 1 8 1.5 15.7 3.6 23.5 5.5l27.8 6.5 25.9 6 23.4 6 24.4 6c7.6 2.2 15 5 22.6 6.8 3 .7 6.6-.8 9.9-1.3l14.9-2.5 22.8-4.3 15.4-2.7q14.8-2.8 29.6-5.3c6.6-1 13.2-2.4 19.8-2.6q27.7-.7 55.3-1.1l32.7-1 34.3-1c9.4-.3 18.9-.2 28.3-1.1 7.6-.8 15.1-2.9 22.7-4.3l41.6-7.6 26-5 27.5-6 30.5-6 28-6c5.1-1 10.4-3 15.6-2.8 9 .3 17.8 2 26.7 3.1q6.7 1 13.6 1.7c9.1.7 18.4 1 27.5 2q21 2.6 42 6.1c7 1.3 13.9 4.1 20.9 6 6.6 1.8 13.5 3 20 5q11.7 3.7 23 8.3c3.8 1.5 7.1 4 10.8 5.6 1.3.6 3 .3 4.6 0l24.9-6 35.7-8.3a36 36 0 0 1 20.5 1.8c5.5 1.8 11.4 2.3 17.1 3.5l21.3 4.2 15.3 2.8c8.8 2 18.1 2.8 26.2 6.5a22 22 0 0 0 17.6 1.6c12.7-4.2 25.8-7 38.2-11.9 7-2.8 13-1.5 19.6 0l20.5 3.8 28 5.5 34.7 6.5 29.2 6.3q10.8 2 21.5 3.7l25.3 4.3 17.4 2.7q13.2 2 26.4 3.7 6 .9 12.2 1.3c5.6.4 11.3 0 16.7 1.1 31.1 6.9 62.6 2.7 93.9 3.9l31.2 1q.6 98 .5 196H1z" />
    </svg>
    <div class="login-content-stack">
      @if(announcementData())
      {
      <div class="row">
        <div class="col-12">
          <app-announcement [announcementItem]="announcementData()"></app-announcement>
        </div>
      </div>
      }
      <div class="login-card" [ngClass]="cardClass()" #loadingContainer>
        <div class="loading-container">
          <!-- MDB Loading with backdrop -->
          <mdb-loading [backdrop]="true" [backdropClass]="'custom-loading-backdrop'" [show]="isLoading()"
            [container]="loadingContainer" [fullscreen]="false" role="status" aria-label="Loading"
            [attr.aria-hidden]="!isLoading()">
          </mdb-loading>
          <!-- Loading box as sibling, shown separately -->
          @if (isLoading()) {
          <div class="loading-box" role="status" aria-live="polite">
            <div class="fas fa-spinner fa-spin fa-3x loading-icon" aria-hidden="true"></div>
            <p class="loading-text">Loading...</p>
          </div>
          }
        </div>
        <!-- Logo Section -->
        <div class="card-logo-section">
          <div class="card-logo">
            <!-- Logo SVG here -->
            <svg class="responsive-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900" role="img"
              aria-label="Superior Court of San Bernardino logo">
              <path class="logo-light"
                d="M261.9 307c-.3-4.2-.9-8.4-.8-12.6 0-8.1.8-16.2.9-24.3v-37.5l1-79.8 1-70.8q.6-19.3 1.5-39.2l29.7 19.9 77 52.4 74.6 50.8 72.7 49.3 74.1 50.7q48.8 33 97.4 66.3c1.7 1.2 2.9 4.4 2.9 6.6q.2 43.5.1 87c0 48.1-.2 96.3.2 144.4 0 6.7-2.4 10.1-7.7 12.7q-1.4.9-3.4 1.6l-3.5-2.7-50.5-33.2-135.8-89.4q-2.6-1.4-5.4-2.4-13.1-9-26.4-17.7l-43-28.3c-1-1.2-1.4-2.4-2.2-3l-52.4-34.4q-47.5-31.6-95-62.8-3.4-2-7-3.5" />
              <path class="logo-dark"
                d="M487.6 457q3 .7 5.7 2.2L629 548.6l50.5 33.2q1.5 1 3.2 2.8-17.6 10.9-35.4 21.5L584 644.5 520.5 683l-63.4 38.4-68.4 41.4-63 38.3q-29.8 18-59.6 36.3-1.4.8-4.2 2c-.3-2-.9-3.7-.9-5.4l-.1-231c0-4.1 2.4-5 5-6.6l40.2-26 85.7-54.4 29-18.4v41l33.4-41.1 21.1-25.4z" />
              <path class="logo-darker"
                d="M262 307.5q3.5 1 6.8 3l95.1 63 52.4 34.3q1 1 1.8 3v42.7c0 3-.8 4.6-3.3 6.4q-32.1 21.7-64.1 43.6L286 547l-21.8 15-.9-.2-.3-.4q-.5-.3-.7-.7l-.3-1V307.6" />
            </svg>
            <!-- Hide title on non-mobile screens -->
            <div class="login-title d-block d-md-none">
              <h1>SUPERIOR COURT OF SAN BERNARDINO</h1>
              <p>DIRECT ACCESS TO SELF-HELP</p>
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- Login Form -->
          <div id="loginScreen" class="screen card-content" [class.active]="currentForm() === 'login'"
            [class.slide-out-left]="currentForm() !== 'login'" [attr.aria-hidden]="currentForm() !== 'login'"
            [attr.inert]="currentForm() !== 'login' ? '' : null">
            <h2 class="login-title">Sign In</h2>
            <app-gradientsegmentbar></app-gradientsegmentbar>
            <!-- Login Form Alert Section -->
            @if (errorState() && currentForm() === 'login') {
            <div class="alert mb-4" [class.alert-danger]="errorState()?.type === 'error'"
              [class.alert-warning]="errorState()?.type === 'warning'"
              [class.alert-success]="errorState()?.type === 'success'"
              [class.alert-info]="errorState()?.type === 'info'" role="alert">
              {{ errorState()?.message }}
            </div>
            }
            @if (alertState() && currentForm() === 'login') {
            <div class="alert mb-4" [class.alert-danger]="alertState()?.type === 'error'"
              [class.alert-success]="alertState()?.type === 'success'"
              [class.alert-info]="alertState()?.type === 'info'" role="alert">
              {{ alertState()?.message }}
            </div>
            }
            @if (isOtpLocked()) {
            <div class="alert alert-warning mb-4" role="alert">
              <i class="fas fa-lock me-2" aria-hidden="true"></i>
              Too many failed attempts. Please try again later.
            </div>
            }
            <form [formGroup]="loginForm" (submit)="handleLogin($event)">
              <div class="row mb-1">
                <mdb-form-control class="mb-4">
                  <input mdbValidate mdbInput type="text" id="email" formControlName="email" class="form-control"
                    [attr.aria-describedby]="email.invalid && (email.dirty || email.touched) ? 'email-error' : null"
                    aria-label="Email or Phone Number" required />
                  <label mdbLabel class="form-label" for="email">Email or Phone Number</label>
                  @if (email.invalid && (email.dirty || email.touched)) {
                  <mdb-error id="email-error">
                    @if (email.errors?.['required']) {
                    Email or phone number is required
                    }
                    @if (email.errors?.['invalidEmail']) {
                    Please enter a valid email address
                    }
                    @if (email.errors?.['invalidPhone']) {
                    Please enter a valid 10-digit phone number
                    }
                    @if (email.errors?.['invalidCountryCode']) {
                    Only USA phone numbers (+1) are accepted
                    }
                  </mdb-error>
                  }
                  @if (email.valid && (email.dirty || email.touched)) {
                  <mdb-success></mdb-success>
                  }
                </mdb-form-control>
              </div>
              <div class="row mb-1">
                <div class="d-grid gap-2">
                  <button type="submit" class="btn btn-lg register-button" mdbRipple>
                    Sign In
                  </button>
                </div>
              </div>
            </form>
            <div class="row mb-1">
              <div class="col-12">
                <hr class="hr my-4">
              </div>
              <div class="d-grid gap-2">
                <button class="btn btn-lg btn-outline-tertiary" href="#" [disabled]="isOtpLocked()"
                  (click)="showRegistrationForm(); $event.preventDefault()">Create Account</button>
              </div>
            </div>
          </div>

          <!-- Registration Form -->
          <div id="registrationScreen" class="screen registration-screen" [class.active]="currentForm() === 'register'"
            [class.slide-in-from-left]="currentForm() === 'register'" [attr.aria-hidden]="currentForm() !== 'register'"
            [attr.inert]="currentForm() !== 'register' ? '' : null">
            <h2 class="login-title">Create Account</h2>
            <app-gradientsegmentbar></app-gradientsegmentbar>
            <!-- Registration form Alert section -->
            @if (alertState() && currentForm() === 'register') {
            <div class="alert mb-4" [class.alert-danger]="alertState()?.type === 'error'"
              [class.alert-success]="alertState()?.type === 'success'"
              [class.alert-info]="alertState()?.type === 'info'" role="alert" aria-live="polite" aria-atomic="true">
              {{ alertState()?.message }}
            </div>
            }
            <form [formGroup]="registrationForm" (submit)="createAccount($event)">
              <div class="row mb-1">
                <div class="col-md-6">
                  <mdb-form-control class="mb-4">
                    <input mdbValidate mdbInput type="text" id="firstName" formControlName="firstName"
                      class="form-control" aria-label="First Name"
                      [attr.aria-describedby]="firstName.invalid && (firstName.dirty || firstName.touched) ? 'firstName-error' : null"
                      required />
                    <label mdbLabel class="form-label" for="firstName">First Name</label>
                    @if (firstName.invalid && (firstName.dirty || firstName.touched)) {
                    <mdb-error id="firstName-error" class="mt-n1">First name is required.</mdb-error>
                    }
                    @if (firstName.valid && (firstName.dirty || firstName.touched)) {
                    <mdb-success></mdb-success>
                    }
                  </mdb-form-control>
                </div>
                <div class="col-md-6">
                  <mdb-form-control class="mb-4">
                    <input mdbValidate mdbInput type="text" id="lastName" formControlName="lastName"
                      class="form-control"
                      [attr.aria-describedby]="lastName.invalid && (lastName.dirty || lastName.touched) ? 'lastName-error' : null"
                      aria-label="Last Name" required />
                    <label mdbLabel class="form-label" for="lastName">Last Name</label>
                    @if (lastName.invalid && (lastName.dirty || lastName.touched)) {
                    <mdb-error class="mt-n1">Last name is required.</mdb-error>
                    }
                    @if (lastName.valid && (lastName.dirty || lastName.touched)) {
                    <mdb-success></mdb-success>
                    }
                  </mdb-form-control>
                </div>
              </div>
              <fieldset aria-label="Contact information - email or phone number is required">
                <div class="row d-flex align-items-center">
                  <div class="col-12">
                    <!-- Email -->
                    <mdb-form-control>
                      <input mdbValidate mdbInput type="email" id="regEmail" formControlName="email"
                        class="form-control"
                        [attr.aria-describedby]="regEmail.invalid && regEmail.dirty ? 'regEmail-error' : null" />
                      <label mdbLabel class="form-label" for="regEmail">Email</label>
                      @if (regEmail.invalid && regEmail.dirty)
                      {
                      <div class="mt-3">
                        <mdb-error id="regEmail-error">
                          @if(regEmail.errors?.['email'])
                          {
                          Please enter a valid email address
                          }
                          @else if (regEmail.errors?.['contactRequired'])
                          {
                          One contact method required.
                          }
                        </mdb-error>
                      </div>
                      }
                      @if (regEmail.valid && regEmail.value?.trim() && regEmail.dirty) {
                      <mdb-success></mdb-success>
                      }
                    </mdb-form-control>
                  </div>
                  <!-- email/phone "or" divider  -->
                  <div class="col-12">
                    <div class="row">
                      <div class="col col-sm-2 col-md-1 my-0">
                        <hr class="form-hr" style="color:#444" />
                      </div>
                      <div class="col col-sm-1 col-md-1  text-center form-hr-text fw-semibold" style="color:#444">
                        or
                      </div>
                      <div class="col  col-sm-2 col-md-1  my-0">
                        <hr class="form-hr" style="color:#444" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <!-- Phone -->
                    <mdb-form-control class="mb-4">
                      <input mdbValidate mdbInput type="tel" id="phone" formControlName="phone" class="form-control"
                        placeholder="(555) 555-5555"
                        [attr.aria-describedby]="phone.invalid && phone.dirty ? 'phone-error' : null" />
                      <label mdbLabel class="form-label" for="phone">Phone Number</label>
                      @if (phone.invalid && phone.dirty) {
                      <mdb-error id="phone-error">
                        @if (phone.errors?.['invalidPhone']) {
                        Please enter a valid 10-digit phone number
                        }
                        @else if (phone.errors?.['contactRequired'])
                        {
                        One contact method required.
                        }
                      </mdb-error>
                      }
                      @if(phone.dirty && phone.valid && phone.value && phone.value.trim().length > 0) {
                      <mdb-success></mdb-success>
                      }
                    </mdb-form-control>

                    @if (registrationForm.hasError('atLeastOneContact') &&
                    ((phone.dirty || phone.touched) || (regEmail.dirty || regEmail.touched))) {
                    <div class="alert alert-warning mb-3" role="alert">
                      Please provide at least one contact method.
                    </div>
                    }
                  </div>
                </div>
              </fieldset>
              <div class="checkbox-group">
                <!-- Agree to SMS -->
                @if (phone.dirty && phone.valid && phone.value && phone.value.trim().length > 0){
                  <div class="form-check mb-4">
                    <input class="form-check-input" mdbCheckbox type="checkbox" id="agreeSMSCheck"
                      formControlName="agreeSMSCheck" aria-required="false">
                    <label for="agreeSMSCheck">
                      By checking this box, I agree to receive text notifications from the Court about
                      my Direct Access to Self-Help account, including account updates, service request status,
                      and appointment/workshop reminders. Message frequency varies. Message & data rates may apply.
                      Reply STOP to cancel or HELP for assistance. Consent not required for services.
                    </label>
                  </div>
                }
                <!-- Attestation -->
                <div class="form-check mb-4">
                  <input class="form-check-input" mdbCheckbox type="checkbox" id="attorneyCheck"
                    formControlName="attorneyCheck"
                    [attr.aria-describedby]="attorneyCheck.hasError('required') && (attorneyCheck.dirty || attorneyCheck.touched) ? 'checkbox-errors' : null"
                    required>
                  <label for="attorneyCheck" class="form-check-label">
                    <span class="form-required-asterisk" aria-hidden="true">*</span>
                    <span class="visually-hidden">(required)</span>
                    I confirm I am not an attorney and I am not currently represented by an attorney of record.
                  </label>
                </div>
                <!-- Terms & Conditions -->
                <div class="form-check mb-4">
                  <input class="form-check-input" type="checkbox" id="termsCheck" formControlName="termsCheck"
                    [attr.aria-describedby]="termsCheck.hasError('required') && (termsCheck.dirty || termsCheck.touched) ? 'checkbox-errors' : null"
                    required>
                  <label for="termsCheck" class="form-check-label">

                    <span class="form-required-asterisk" aria-hidden="true">*</span>
                    <span class="visually-hidden">(required)</span>
                    I agree to the
                    <a class="fw-bold" href="/DASH_Terms_And_Conditions_Of_Use.pdf" target="_blank"
                      rel="noopener noreferrer">
                      Terms and Conditions <span class="visually-hidden">(opens in a new tab)</span>
                    </a>
                    and <a class="fw-bold" href="/DASH_Privacy_Policy.pdf" target="_blank" rel="noopener noreferrer">
                      Privacy Policy <span class="visually-hidden">(opens in a new tab)</span>
                    </a>
                  </label>
                </div>
              </div>
              @if ((attorneyCheck.hasError('required') && (attorneyCheck.dirty ||
              attorneyCheck.touched))||(termsCheck.hasError('required') && (termsCheck.dirty || termsCheck.touched))) {
              <div class="alert alert-warning mb-3" role="alert" id="checkbox-errors" aria-live="polite">
                Agreement required to continue.
              </div>
              }
              <div class="d-grid gap-2" style="padding-bottom:30px;">
                <button type="submit" class="btn btn-lg register-button" mdbRipple>
                  Submit
                </button>
              </div>
              <a href="#" class="back-button" (click)="showLoginForm(); $event.preventDefault()">
                <i class="fas fa-arrow-left" aria-hidden="true"></i>
                <span>Back</span>
              </a>
            </form>
          </div>
          <!-- Verification Form -->
          <div id="verificationScreen" class="screen verification-screen"
            [class.active]="currentForm() === 'verification'" [attr.aria-hidden]="currentForm() !== 'verification'"
            [attr.inert]="currentForm() !== 'verification' ? '' : null">
            <h2 class="login-title">Verification Code</h2>
            <app-gradientsegmentbar></app-gradientsegmentbar>
            <!-- Verification Form Alert Section -->
            @if (alertState() && currentForm() === 'verification') {
            <div class="alert mb-4" [class.alert-danger]="alertState()?.type === 'error'"
              [class.alert-success]="alertState()?.type === 'success'"
              [class.alert-info]="alertState()?.type === 'info'" role="alert">
              {{ alertState()?.message }}
            </div>
            }
            @if (isOtpLocked()) {
            <div class="alert alert-warning mb-4" role="alert">
              <i class="fas fa-lock me-2" aria-hidden="true"></i>
              Too many failed attempts. Please try again later.
            </div>
            }
            <div class="verification-message" [innerHTML]="verificationMessage()"></div>
            <form (submit)="submitVerificationCode($event)">
              <div class="code-inputs-container" role="group" aria-labelledby="code-label">
                <span id="code-label" class="visually-hidden">Enter verification code</span>
                @for (code of verificationCode(); track $index) {
                <input [id]="'code-digit-' + ($index + 1)" [disabled]="isOtpLocked()"
                  [attr.aria-label]="'Verification Code Digit ' + ($index + 1) + ' of ' + verificationCode().length"
                  type="text" class="code-input" maxlength="1" inputmode="numeric" pattern="[0-9]"
                  autocomplete="one-time-code" [value]="verificationCode()[$index]"
                  (input)="onCodeInput($index, $event)" (keydown)="onCodeKeydown($index, $event)"
                  (paste)="onCodePaste($index, $event)" required>
                }
              </div>
              <div class="d-grid gap-2">
                <button id="verificationSubmit" type="submit" class="btn btn-lg submit-button"
                  [disabled]="!isVerificationCodeComplete() || otpLocked()" mdbRipple>Submit</button>
              </div>
              <div class="col-12">
                <hr class="hr my-4">
              </div>
              <div class="row mb-1">
                <div class="d-grid gap-2" style="padding-bottom:30px;">
                  <button type="button" class="btn btn-lg btn-outline-tertiary"
                    [disabled]="resendCountdown() > 0 || isOtpLocked() || resendInFlight()"
                    (click)="resendCode(); $event.preventDefault()">
                    {{ resendButtonText() }}
                  </button>
                </div>
              </div>
            </form>
            <a href="#" class="back-button" (click)="backFromVerification(); $event.preventDefault()">
              <i class="fas fa-arrow-left" aria-hidden="true"></i>
              <span>Back</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
